import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavigationContent() {
  const {
    menuItems,
    loading,
    error
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex space-x-6">
        {[...Array(4)].map((_, i) => <div key={i} className="h-4 w-16 bg-muted-light animate-pulse rounded"></div>)}
      </div>;
  }
  if (error) {
    return null;
  }
  return <>
      <NavigationMenu className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.filter(item => item.id !== "486").map((item, index) => <NavigationMenuItem key={item.id} data-index={index}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className={`${item.id === "486" || item.href?.includes("tel:") ? "text-accent hover:text-accent-hover flex items-center" : "text-foreground hover:text-primary"} transition-colors duration-[var(--duration-fast)] font-medium`}>
                  {(item.id === "486" || item.href?.includes("tel:")) && <Phone className="size-4 mr-1" />}
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
        <Link to="tel:4695575547" className="flex items-center gap-2 ml-6 text-accent hover:text-accent-hover transition-colors duration-[var(--duration-fast)] font-medium text-sm whitespace-nowrap">
          <Phone className="size-4" />
          (469) 557-5547
        </Link>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu">
        {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </Button>

      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-t border-muted-light shadow-medium md:hidden z-50">
          <nav className="container py-4">
            <div className="flex flex-col space-y-2">
              {menuItems.map((item, index) => <Link key={item.id} data-index={index} to={item.href || "#"} className="px-4 py-3 text-foreground hover:text-primary hover:bg-primary-light-bg rounded-sm transition-all duration-[var(--duration-fast)] font-medium" onClick={() => setIsMobileMenuOpen(false)}>
                  {item.label}
                </Link>)}
            </div>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  return <header className="sticky top-0 z-40 w-full bg-background/95 backdrop-blur-sm border-b border-muted-light">
      <div className="container">
        <div className="flex items-center justify-between h-16">
          <Link to="/HomePage" className="flex items-center gap-3">
            <img src="https://ironpeakmenshealth.com/wp-content/uploads/2025/09/cropped-cropped-Mens-Health-Logo-e1770677582570.png" alt="Iron Peak Men's Health Logo" className="h-14" />
            <span className="font-display font-semibold text-xl text-[#2B4F81]">
              IronPeak Men's Health
            </span>
          </Link>

          <MenuProvider menu_id="17">
            <NavigationContent />
          </MenuProvider>
        </div>
      </div>
    </header>;
}